import {
    BlockingScopes,
    BlockingSourceFormation,
    BlokcingReason,
    UnblockingReason,
} from './products-blocking';

export const BLOCKING_AUDIT_EVENTS = [
    'BLOCKING_DOCUMENT_CREATED',
    'BLOCKING_DOCUMENT_PROCESSING',
    'BLOCKING_DOCUMENT_COMPLETED',
    'BLOCKING_DOCUMENT_REJECTED',
    'BLOCKING_CREATED',
    'BLOCKING_REMOVED',
] as const;

export type BlockingAuditEventType = typeof BLOCKING_AUDIT_EVENTS[number];

export interface BlockingAuditEntry {
    eventId: string;
    eventType: BlockingAuditEventType;
    eventTimestamp: string;
    userId?: string;
    userFullName?: string;
    userRole?: string;
    clientId?: number;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    ipAddress?: string;
    userAgent?: string;
    documentId?: string;
    sourceFormation?: BlockingSourceFormation;
    reason?: BlokcingReason;
    scopes?: BlockingScopes[];
    affectedCodesCount?: number;
    errorCode?: string;
    rejectionReason?: string;
    failedMarkingCodes?: string[];
    blockingId?: string;
    markingCode?: string;
    operator?: string;
    createdAt?: string;
    removedAt?: string;
    removedBy?: string;
    unblockingReason?: UnblockingReason;
    unblockingComment?: string;
}

export interface BlockingAuditParams {
    userFullName?: string;
    organizationName?: string;
    organizationTin?: string;
    eventType?: string;
    from?: string;
    to?: string;
    documentId?: string;
    blockingId?: string;
    markingCode?: string;
    reason?: string;
    unblockingReason?: string;
    sourceFormation?: string;
    page?: number;
    size?: number;
}

export interface BlockingAuditPage {
    data: BlockingAuditEntry[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
